import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Loader } from "../../../loaders/Loader";
import { useFetchPavementGroupsDictQuery } from "../../../../api/rtk/base/slices/objectTypes/roadBedLayersApiSlice";

export default function RoadsLengthByBedTypeChart() {
    const [chartData, setChartData] = useState<any>(null)
    const [chartIsShown, setChartIsShown] = useState<boolean>(true)
    const [chartXAxisTicks, setChartXAxisTicks] = useState<any>([])

    const {
        data: pavementGroups,
        isFetching: pavementGroupsAreFetching,
        isError: pavementGroupsRequestIsError
    } = useFetchPavementGroupsDictQuery({})

    useEffect(() => {
        if (!pavementGroups) {
            setChartData(null)
            setChartXAxisTicks([])
            return
        }

        const year = new Date().getFullYear() - 1
        let data = { year }
        let maxDataX = 0

        pavementGroups.value.forEach((pavementGroup: any) => {
            const { RoadbedTypeID, Length } = pavementGroup ?? {}
            if (typeof Length !== "number") return
            if (Length > maxDataX) maxDataX = Length
            data[RoadbedTypeID] = Length.toFixed(1)
        })

        setChartData([data])
        setChartXAxisTicks(Array.from(
            { length: Math.floor((maxDataX + 1000) / 500) + 1 },
            (_, i) => i * 500
        ))
    }, [pavementGroups])

    useEffect(() => {
        if (!pavementGroups) {
            setChartIsShown(false)
            return
        }

        const hasAtLeastOneFilled = pavementGroups.value.some((pavementGroup: any) => {
            const length = pavementGroup?.Length
            return typeof length === "number" && length !== 0
        })

        setChartIsShown(hasAtLeastOneFilled)
    }, [pavementGroups])

    const labelStyle: any = { fill: "black", position: 'top', fontSize: "13" }
    const yearAxisTickFormatter = (value: any) => `${value} г.`
    const legendFormatter = (value: any) => <span className="legend-text">{value}</span>

    const chartTooltipTemplate: any = ({ payload }: any) => {
        const chartData = payload[0]?.payload
        const { year, 1: fundamental, 2: lightweight, 3: transitional, 4: inferior } = chartData ?? {}
        return (
            <div className="chart-tooltip">
                <p>Год: <strong>{year}</strong></p>
                {fundamental && <p>Капитальный: <span id="fund-value">{fundamental}</span> км</p>}
                {lightweight && <p>Облегчённый: <span id="light-value">{lightweight}</span> км</p>}
                {transitional && <p>Переходный: <span id="trans-value">{transitional}</span> км</p>}
                {inferior && <p>Низший: <span id="inf-value">{inferior}</span> км</p>}
            </div>
        )
    }

    return (
        <>
            {pavementGroupsAreFetching
                ?
                <Loader />
                :
                <>
                    {chartIsShown
                        ?
                        <ResponsiveContainer width="100%" height={357}>
                            <BarChart
                                data={chartData}
                                layout="horizontal"
                                margin={{ right: 30, bottom: 15, top: 15 }}
                                className="roads-length-by-bed-type-chart"
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                <YAxis type="number" ticks={chartXAxisTicks} axisLine={false} tickLine={false} tick={{ fill: "#999999" }} />
                                <XAxis dataKey="year" tickFormatter={yearAxisTickFormatter} tick={{ fill: "black" }}/>
                                <Legend formatter={legendFormatter} align="center" />
                                <Tooltip content={chartTooltipTemplate} />
                                <Bar dataKey="1" name="Капитальный" fill="#005CC2" barSize={30} label={labelStyle} />
                                <Bar dataKey="2" name="Облегчённый" fill="#7DA2DF" barSize={30} label={labelStyle} />
                                <Bar dataKey="3" name="Переходный" fill="#1faee9" barSize={30} label={labelStyle} />
                                <Bar dataKey="4" name="Низший" fill="#afdafc" barSize={30} label={labelStyle} />
                            </BarChart>
                        </ResponsiveContainer>
                        :
                        <div className="panel-no-content">
                            <span>Нет информации</span>
                        </div>
                    }
                </>
            }
        </>
    )
}
